import { DSAR_DETAILS_FIELD_IDS } from '/b2b/dsarForms/constants';

/** Limit for fetching DSAR forms/request types (e.g. dropdowns). */
export const DSAR_FORM_FETCH_LIMIT = 1000;

export const EVENTS = {
    BULK_COMPLETE_REQUEST: 'BulkCompleteRequest',
    BULK_REJECT_REQUEST: 'BulkRejectRequest',
    COMPLETE_REQUEST: 'CompleteRequest',
    CREATE_REQUEST: 'CreateDSARRequest',
    OPEN_ACTIVITY_LOG: 'OpenActivityLog',
    OPEN_INFO: 'OpenInfo',
    OPEN_STATUS: 'OpenStatus',
    REJECT_REQUEST: 'RejectRequest',
    REQUESTS_FILTER: 'RequestsFilter',
    SEND_MESSAGE: 'SendMessage',
    VERIFY_IDENTITY: 'VerifyIdentity',
};

export const DSAR_STATUS_KEYS = {
    PENDING_EMAIL_VERIFICATION: 'PENDING_EMAIL_VERIFICATION',
    PENDING_IDENTITY_VERIFICATION: 'PENDING_IDENTITY_VERIFICATION',
    IN_PROGRESS: 'IN_PROGRESS',
    IN_REVIEW: 'IN_REVIEW',
    PENDING_APPEAL: 'PENDING_APPEAL',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED',
    REJECTED_AUTO: 'REJECTED_AUTO',
};

// pseudo status for RequestStepper.component.jsx
export const PENDING_VERIFICATION_KEY = 'PENDING_VERIFICATION';
export const PENDING_VERIFICATION_LABEL = 'dsar.status.pendingVerification';
export const IN_PROGRESS_LABEL = 'dsar.status.actionItems';

export const DSAR_STATUS = {
    [DSAR_STATUS_KEYS.PENDING_APPEAL]: 'dsar.status.pendingAppeal',
    [DSAR_STATUS_KEYS.PENDING_EMAIL_VERIFICATION]: 'dsar.status.pendingEmailVerification',
    [DSAR_STATUS_KEYS.PENDING_IDENTITY_VERIFICATION]: 'dsar.status.pendingIdentityVerification',
    [DSAR_STATUS_KEYS.IN_PROGRESS]: 'dsar.status.inProgress',
    [DSAR_STATUS_KEYS.IN_REVIEW]: 'dsar.status.inReview',
    [DSAR_STATUS_KEYS.COMPLETED]: 'dsar.status.completed',
    [DSAR_STATUS_KEYS.REJECTED]: 'dsar.status.rejected',
    [DSAR_STATUS_KEYS.REJECTED_AUTO]: 'dsar.status.rejectedAuto',
};

export const DSAR_AUTO_STATUSES = [DSAR_STATUS_KEYS.REJECTED_AUTO];

export const DSAR_VERIFICATION_STATUSES = [
    DSAR_STATUS_KEYS.PENDING_EMAIL_VERIFICATION,
    DSAR_STATUS_KEYS.PENDING_IDENTITY_VERIFICATION,
];

export const DSAR_COMPLETED_STATUSES = [DSAR_STATUS_KEYS.COMPLETED];

export const DSAR_REJECTED_STATUSES = [DSAR_STATUS_KEYS.REJECTED, DSAR_STATUS_KEYS.REJECTED_AUTO];

export const DSAR_FINISHED_STATUSES = [...DSAR_COMPLETED_STATUSES, ...DSAR_REJECTED_STATUSES];

export const DSAR_REVIEW_STATUSES = [DSAR_STATUS_KEYS.IN_REVIEW, DSAR_STATUS_KEYS.PENDING_APPEAL];

export const DSAR_SUBSTATUS_KEYS = {
    ALL_ACTION_ITEMS_COMPLETE: 'ALL_ACTION_ITEMS_COMPLETE',
    NO_RESULTS_FOUND: 'NO_RESULTS_FOUND',
    NO_ACTION_ITEMS_GENERATED: 'NO_ACTION_ITEMS_GENERATED',
    ACTION_ITEMS_IN_PROGRESS: 'ACTION_ITEMS_IN_PROGRESS',
    EMAIL_VERIFIED: 'EMAIL_VERIFIED',
    EMAIL_VERIFICATION_PENDING: 'EMAIL_VERIFICATION_PENDING',
};

export const DSAR_NEXT_STEP_LABELS = {
    [DSAR_STATUS_KEYS.PENDING_EMAIL_VERIFICATION]: 'dsar.nextStepLabel.pendingEmailVerification',
    [DSAR_STATUS_KEYS.PENDING_IDENTITY_VERIFICATION]:
        'dsar.nextStepLabel.pendingIdentityVerification',
    [DSAR_STATUS_KEYS.IN_PROGRESS]: 'dsar.nextStepLabel.readyForReview',
    [DSAR_STATUS_KEYS.IN_REVIEW]: 'dsar.nextStepLabel.readyForCompletion',
    [DSAR_STATUS_KEYS.PENDING_APPEAL]: 'dsar.nextStepLabel.readyForCompletion',
};

export const DSAR_REJECTION_REASONS = {
    OTHER: 'dsar.rejectionReason.other',
};

export const REJECTION_REASONS = {
    REJECTED_APPEAL: 'REJECTED_APPEAL',
};

/** Field IDs required in CSV import templates and validation. */
export const DSAR_CSV_REQUIRED_FIELD_IDS = [
    DSAR_DETAILS_FIELD_IDS.EMAIL,
    DSAR_DETAILS_FIELD_IDS.REQUEST_TYPE,
    DSAR_DETAILS_FIELD_IDS.STATUS,
];

/** Read-only field IDs; not editable in request details, disabled in edit dialogs. */
export const DSAR_READ_ONLY_FIELD_IDS = [
    DSAR_DETAILS_FIELD_IDS.EMAIL,
    DSAR_DETAILS_FIELD_IDS.REQUEST_ID,
    DSAR_DETAILS_FIELD_IDS.FORM_ID,
    DSAR_DETAILS_FIELD_IDS.CREATED,
    DSAR_DETAILS_FIELD_IDS.PRIVACY_LAW_DEADLINE,
    DSAR_DETAILS_FIELD_IDS.PRIVACY_LAW,
    DSAR_DETAILS_FIELD_IDS.COUNTRY_GEO,
    DSAR_DETAILS_FIELD_IDS.TERRITORY_GEO,
    DSAR_DETAILS_FIELD_IDS.DUE_DATE,
    DSAR_DETAILS_FIELD_IDS.DUE,
    DSAR_DETAILS_FIELD_IDS.REQUEST_TYPE,
    DSAR_DETAILS_FIELD_IDS.VERIFIED_DATE,
];

export const DSAR_REQUEST_DETAILS_OMIT_KEYS_TO_DOWNLOAD = [
    'requestDetails.country',
    'requestDetails.customer-id',
    'requestDetails.email',
    'requestDetails.form-id',
    'requestDetails.request-source',
    'requestDetails.request-type',
    'requestDetails.request-type-description',
    'requestDetails.request-type-id',
    'requestDetails.request-type-instructions',
    'requestDetails.request-type-title',
    'requestDetails.territory',
    'requestDetails.form.**',
    'templates.**',
];
